/**
 * Load optional product-detail components only when their blocks are present.
 * The current product templates do not render SKU or inventory blocks, but
 * keeping this detector allows those blocks to be added later in the editor.
 */
const optionalComponents = [
  ['product-sku-component', () => import('@theme/product-sku')],
  ['product-inventory', () => import('@theme/product-inventory')],
];

const requested = new Set();

function loadPresentComponents(root = document) {
  for (const [selector, load] of optionalComponents) {
    if (requested.has(selector)) continue;

    const isMatch = root instanceof Element && root.matches(selector);
    if (!isMatch && !root.querySelector(selector)) continue;

    requested.add(selector);
    load().catch(() => requested.delete(selector));
  }
}

loadPresentComponents();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) loadPresentComponents(event.target);
});
